import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file
import { ORDER_TYPES } from '@exodus/fiat-client'

const resultFunction = (cryptoAssets) =>
  memoize((orderType, assets) =>
    Object.fromEntries(
      Object.values(assets)
        .filter(
          (asset) =>
            Boolean(cryptoAssets[asset.name]) &&
            Object.values(cryptoAssets[asset.name]?.providers ?? {}).some(
              (provider) =>
                provider[orderType === ORDER_TYPES.buy ? 'isBuySupported' : 'isSellSupported']
            )
        )
        .map((asset) => [asset.name, { ...asset, ...cryptoAssets[asset.name] }])
    )
  )

const createCryptoAssetsFromOrderTypeSelectorDefinition = {
  id: 'createCryptoAssetsFromOrderType',
  resultFunction,
  dependencies: [{ selector: 'cryptoAssets' }],
}

export default createCryptoAssetsFromOrderTypeSelectorDefinition
